import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evo-decoration-background',
  templateUrl: './evo-decoration-background.component.html',
  styleUrls: ['./evo-decoration-background.component.css']
})
export class EvoDecorationBackgroundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
